import type { IData } from '../model/IData'
import { expectDefined } from './expectDefined'
import { getCouples } from './getCouples'

export function getSpouses(data: IData, personId: string) {
	return getCouples(data, personId)
		.map((it) => (it.maleId === personId ? it.femaleId : it.maleId))
		.filter((it) => it != null)
		.map((it) => expectDefined(data.personsById[it]))
}
